import { Injectable } from '@angular/core';
import {StorageMap} from '@ngx-pwa/local-storage';
import {AuthResponse} from '../../shared/interfaces/auth-response';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly USER_INFO = 'USER_INFO';

  constructor(private storage: StorageMap) { }

  async setTokens(tokens: AuthResponse): Promise<boolean> {
    return await new Promise((resolve, reject) => {
      try {
        this.storage.set(this.JWT_TOKEN, tokens.access_token).subscribe((data) => {
          resolve(data);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
  async getToken(): Promise<string> {
    return await new Promise((resolve, reject) => {
      try {
        this.storage.get(this.JWT_TOKEN, {type: 'string'}).subscribe((data) => {
          resolve(data);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
  async removeToken(): Promise<boolean> {
    return await new Promise((resolve, reject) => {
      try {
        this.storage.delete(this.JWT_TOKEN).subscribe((data) => {
          resolve(data);
        });
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
}
